import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const LoginPage = Loadable(lazy(() => import('views/pages/authentication/login')));
const LandingPage = Loadable(lazy(() => import('views/pages/landing')));
const SearchPage = Loadable(lazy(() => import('views/pages/search')));
const ApplicationPage = Loadable(lazy(() => import('views/pages/application')));
const ReportPage = Loadable(lazy(() => import('views/pages/reports')));
const IdCards = Loadable(lazy(() => import('views/pages/idcards')));
const LibraryPage = Loadable(lazy(() => import('views/pages/library')));
const StockPage = Loadable(lazy(() => import('views/pages/stockregister')));
const CashBookPage = Loadable(lazy(() => import('views/pages/cashbook')));
const AttendancePage = Loadable(lazy(() => import('views/pages/attendance')));
const DocumentsPage = Loadable(lazy(() => import('views/pages/documents')));

//Config
const CourseconfigPage = Loadable(lazy(() => import('views/pages/config/courseconfig')));
const RouteconfigPage = Loadable(lazy(() => import('views/pages/config/routeconfig')));
const ApprovalPage = Loadable(lazy(() => import('views/pages/approval')));
const AdjustmentPage = Loadable(lazy(() => import('views/pages/adjustment')));
const ShiftAdjustmentConfigPage = Loadable(lazy(() => import('views/pages/config/shiftadjustmentconfig')));
const CommonConfigPage = Loadable(lazy(() => import('views/pages/config/commonconfig')));
const SectionMatrixPage = Loadable(lazy(() => import('views/pages/config/commonconfig/sectionmatrix')));
const SubjectMatrixPage = Loadable(lazy(() => import('views/pages/config/commonconfig/compulsarysubmatrix')));
const SemesterUpdatePage = Loadable(lazy(() => import('views/pages/config/commonconfig/semesterupdate')));
//emahe
const UserEnrollmentPage = Loadable(lazy(() => import('views/pages/userenrollment')));
const EmaheVideos = Loadable(lazy(() => import('views/pages/emahevideos')));
const EmaheConfig = Loadable(lazy(() => import('views/pages/emaheconfig')));
const EmaheMcq = Loadable(lazy(() => import('views/pages/emahemcq')));
const EmaheCalendar = Loadable(lazy(() => import('views/pages/emahecalendar')));
const EmaheLeaves = Loadable(lazy(() => import('views/pages/emaheleaves')));
const EmaheSyllabus = Loadable(lazy(() => import('views/pages/emahesyllabus')));
const EmaheTimeTable = Loadable(lazy(() => import('views/pages/emahetimetable')));
const EmaheNotification = Loadable(lazy(() => import('views/pages/emahenotification')));
const EmaheChatMessages = Loadable(lazy(() => import('views/pages/emahechatmessages')));
const Payroll = Loadable(lazy(() => import('views/pages/payroll')));
const EmaheEventRegistration = Loadable(lazy(() => import('views/pages/emaheeventregistration')));
const EmaheGallery = Loadable(lazy(() => import('views/pages/emahegallery')));
const EmaheLiveClass = Loadable(lazy(() => import('views/pages/emaheliveclass')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: 'dashboard',
            children: [
                {
                    path: '',
                    element: <DashboardDefault />
                }
            ]
        },
        {
            path: 'login',
            children: [
                {
                    path: '',
                    element: <LoginPage />
                }
            ]
        },
        {
            path: 'landing',
            children: [
                {
                    path: '',
                    element: <LandingPage />
                }
            ]
        },
        {
            path: 'search',
            children: [
                {
                    path: '',
                    element: <SearchPage />
                }
            ]
        },
        {
            path: 'application',
            children: [
                {
                    path: '',
                    element: <ApplicationPage />
                }
            ]
        },
        {
            path: 'idcards',
            children: [
                {
                    path: '',
                    element: <IdCards />
                }
            ]
        },
        {
            path: 'reports',
            children: [
                {
                    path: '',
                    element: <ReportPage />
                }
            ]
        },
        {
            path: 'library',
            children: [
                {
                    path: '',
                    element: <LibraryPage />
                }
            ]
        },
        {
            path: 'cashbook',
            children: [
                {
                    path: '',
                    element: <CashBookPage />
                }
            ]
        },
        {
            path: 'attendance',
            children: [
                {
                    path: '',
                    element: <AttendancePage />
                }
            ]
        },
        {
            path: 'documents',
            children: [
                {
                    path: '',
                    element: <DocumentsPage />
                }
            ]
        },
        {
            path: 'emaheconfig',
            children: [
                {
                    path: '',
                    element: <EmaheConfig />
                }
            ]
        },
        {
            path: 'emahegallery',
            children: [
                {
                    path: '',
                    element: <EmaheGallery />
                }
            ]
        },
        {
            path: 'emaheliveclass',
            children: [
                {
                    path: '',
                    element: <EmaheLiveClass />
                }
            ]
        },
        {
            path: 'stockregister',
            children: [
                {
                    path: '',
                    element: <StockPage />
                }
            ]
        },
        {
            path: 'approval',
            children: [
                {
                    path: '',
                    element: <ApprovalPage />
                }
            ]
        },
        {
            path: 'adjustment',
            children: [
                {
                    path: '',
                    element: <AdjustmentPage />
                }
            ]
        },
        {
            path: 'courseconfig',
            children: [
                {
                    path: '',
                    element: <CourseconfigPage />
                }
            ]
        },
        {
            path: 'routeconfig',
            children: [
                {
                    path: '',
                    element: <RouteconfigPage />
                }
            ]
        },
        {
            path: 'shiftadjustmentconfig',
            children: [
                {
                    path: '',
                    element: <ShiftAdjustmentConfigPage />
                }
            ]
        },
        {
            path: 'commonconfig',
            children: [
                {
                    path: '',
                    element: <CommonConfigPage />
                }
            ]
        },
        {
            path: 'sectionmatrix',
            children: [
                {
                    path: '',
                    element: <SectionMatrixPage />
                }
            ]
        },
        {
            path: 'subjectmatrix',
            children: [
                {
                    path: '',
                    element: <SubjectMatrixPage />
                }
            ]
        },
        {
            path: 'semesterupdate',
            children: [
                {
                    path: '',
                    element: <SemesterUpdatePage />
                }
            ]
        },
        {
            path: 'userenrollment',
            children: [
                {
                    path: '',
                    element: <UserEnrollmentPage />
                }
            ]
        },
        {
            path: 'emahevideos',
            children: [
                {
                    path: '',
                    element: <EmaheVideos />
                }
            ]
        },
        {
            path: 'emahesyllabus',
            children: [
                {
                    path: '',
                    element: <EmaheSyllabus />
                }
            ]
        },
        {
            path: 'emahetimetable',
            children: [
                {
                    path: '',
                    element: <EmaheTimeTable />
                }
            ]
        },
        {
            path: 'emahenotification',
            children: [
                {
                    path: '',
                    element: <EmaheNotification />
                }
            ]
        },
        {
            path: 'emahechatmessages',
            children: [
                {
                    path: '',
                    element: <EmaheChatMessages />
                }
            ]
        },
        {
            path: 'emahemcq',
            children: [
                {
                    path: '',
                    element: <EmaheMcq />
                }
            ]
        },
        {
            path: 'emahecalendar',
            children: [
                {
                    path: '',
                    element: <EmaheCalendar />
                }
            ]
        },
        {
            path: 'emaheleaves',
            children: [
                {
                    path: '',
                    element: <EmaheLeaves />
                }
            ]
        },
        {
            path: 'emaheeventregistration',
            children: [
                {
                    path: '',
                    element: <EmaheEventRegistration />
                }
            ]
        },
        {
            path: 'payroll',
            children: [
                {
                    path: '',
                    element: <Payroll />
                }
            ]
        },
        {
            path: 'utils',
            children: [
                {
                    path: 'util-shadow',
                    element: <UtilsShadow />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'tabler-icons',
                    element: <UtilsTablerIcons />
                }
            ]
        },
        {
            path: 'icons',
            children: [
                {
                    path: 'material-icons',
                    element: <UtilsMaterialIcons />
                }
            ]
        },
        {
            path: '/x',
            element: <SamplePage />
        }
    ]
};

export default MainRoutes;
